import * as z from 'zod';

export const GITBOOK_FILES_CONTENT_TYPE = 'application/x-gitbook-files';
export const GITBOOK_CONTEXT_CONTENT_TYPE = 'application/x-gitbook-context';

export function parseTransferData<Type = unknown>(
    obj: unknown,
    schema?: z.ZodType<Type>
): Type | undefined {
    if (!obj || typeof obj !== 'string') {
        return;
    }

    try {
        const parsed = JSON.parse(obj);
        return schema ? schema.parse(parsed) : parsed;
    } catch (err) {
        if (err instanceof z.ZodError) {
            throw err;
        }

        throw new Error(
            `Failed to parse ${GITBOOK_FILES_CONTENT_TYPE} transfer data: ${err.message}`
        );
    }
}

export const GitBookFileTransferDataSchema = z.object({
    downloadURL: z.string(),
    name: z.string(),
    contentType: z.string(),
});

/**
 * Transfer data for a single file.
 */
export type GitBookFileTransferData = z.infer<typeof GitBookFileTransferDataSchema>;

export const GitBookFilesTransferDataSchema = z.record(z.string(), GitBookFileTransferDataSchema);

/**
 * Transfer data for multiple files.
 */
export type GitBookFilesTransferData = z.infer<typeof GitBookFilesTransferDataSchema>;
